import { useRef, useCallback } from "react";
import useComponentSize from "@rehooks/component-size";
import { useWindowSize } from "@react-hook/window-size/throttled";
import { useInView } from "react-intersection-observer";

const useVizualisation = (threshold = 0.4) => {
  // Component size
  const componentRef = useRef(null);
  const { width, height } = useComponentSize(componentRef);

  // Window size
  const [windowWidth, windowHeight] = useWindowSize();

  // Viz is inview
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
    threshold,
    delay: 17,
  });

  // Combine refs
  const ref = useCallback(
    (node) => {
      componentRef.current = node;
      inViewRef(node);
    },
    [inViewRef]
  );

  return {
    ref,
    width,
    height,
    inView,
    windowSize: {
      width: windowWidth,
      height: windowHeight,
    },
  };
};

export default useVizualisation;
